var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{
        disabled: _vm.isUnavailable
    },on:{"click":_vm.showHeat}},[_c('div',{staticClass:"heat-icon"},[_c('img',{attrs:{"src":_vm.eventTypeImage}})]),_c('div',[_c('div',{staticClass:"icon",class:{
        'none': _vm.event.state == 0,
        'start-list': _vm.event.state == 1,
        'in-progress': _vm.event.state == 2,
        'finished': _vm.event.state == 3,
    }},[_vm._v(_vm._s(_vm.shortTitle)+" - "+_vm._s(_vm.event.className))]),_c('div',[_vm._v(_vm._s(_vm.getEventInfo))])])])}
var staticRenderFns = []

export { render, staticRenderFns }